import { z } from 'zod'

export default z.object({
  __typename: z.literal('AssetLink').default('AssetLink'),
  id: z.string(),
})
